import ea from './ea.mp3';

class SoundModel{


    constructor(){
        this.soundFullUrl=ea;
        this.soundRelativeUrl="";
        this.enabled=false;
        this.selectedStyle=null

    }


    getJsCode=()=>{
        let obj={
            soundSrc:this.soundRelativeUrl,
            enabled:this.enabled
        }


        return obj;
    }



    getAsJson=()=>{
        let obj={
            soundFullUrl:this.soundFullUrl,
            soundRelativeUrl:this.soundRelativeUrl,
            enabled:this.enabled,
            selectedStyle:this.selectedStyle
        }


        return obj;
    }

    initFromJson=(obj)=>{
        this.soundFullUrl=obj.soundFullUrl;
        this.soundRelativeUrl=obj.soundRelativeUrl;
        this.enabled=obj.enabled;
        this.selectedStyle=obj.selectedStyle
        
        this.selectedStyle[0].style.border="solid 0px"
        this.selectedStyle[0].style.paddingTop="0px"
    }

    initFromJsonTest4You = (obj) => {
        
        if (obj.soundRelativeUrl != "" && obj.soundRelativeUrl != "NULL") {
            this.soundFullUrl = obj.soundFullUrl;
            this.soundRelativeUrl = obj.soundRelativeUrl;

            this.enabled = true;

        }
    }
}


export default SoundModel;